import React, { Component } from 'react';

import CommonSubHeader from '../../SubHeader';

import './SubHeader.css';
import FullTextSearch from './FullTextSearch';
import { inject, observer } from 'mobx-react';
import AdvancedFilter from './AdvancedFilter';
import AirButton from '../../../../common/components/AirButton';
import { DownloadIcon, NewgroupIcon } from '../../../../common/icons';
import NewGroupModal from './NewGroupModal';

@inject('translationsStore')
@observer
export default class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.NewGroupModalRef = React.createRef();
  }

  componentDidMount = () => {
    this.NewGroupModalInstace = this.NewGroupModalRef.current.wrappedInstance;
  };

  render() {
    const { translationsStore } = this.props;
    return (
      <CommonSubHeader className="GMDSubHeader">
        <AirButton
          onClick={() => {
            this.NewGroupModalInstace.show();
          }}
          size="large"
          className="newgroup"
          icon={<NewgroupIcon style={{ width: '30px', height: '22px' }} />}
          label={translationsStore.translate('newgroup.label')}
        />
        <FullTextSearch placeholder={this.props.translationsStore.translate('search.placeholder')} />
        <div className="filtersExport">
          <AdvancedFilter cars={this.props.cars} />
          <AirButton className="export" icon={<DownloadIcon style={{ width: '13px', height: '16px' }} />} label={translationsStore.translate('export')} onClick={this.props.onExportClick} />
        </div>
        <NewGroupModal ref={this.NewGroupModalRef} width={560} />
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/SubHeader.js